import { inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { map, mergeMap, catchError, switchMap, exhaustMap } from 'rxjs/operators'
import { of } from 'rxjs'
// import { ToastrService } from 'ngx-toastr'
// import { Store } from '@ngrx/store'
// import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import {
  blockDesignation,
  blockDesignationFailure,
  blockDesignationSuccess,
  createDesignation,
  createDesignationFailure,
  createDesignationSuccess,
  deleteDesignation,
  deleteDesignationFailure,
  deleteDesignationSuccess,
  loadDesignations,
  loadDesignationsFailure,
  loadDesignationsSuccess,
  updateDesignation,
  updateDesignationFailure,
  updateDesignationSuccess
} from './designation.actions'
import { DesignationService } from '../../services/designation.service'
import { ToastrService } from 'ngx-toastr'
import { Store } from '@ngrx/store'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'

export const loadDesignations$ = createEffect(
  (actions$ = inject(Actions), designationService = inject(DesignationService)) =>
    actions$.pipe(
      ofType(loadDesignations),
      switchMap(
        (
          action // Use action.filter here
        ) =>
          designationService.getDesignations(action.params, action.page, action.limit).pipe(
            map(res =>
              loadDesignationsSuccess({
                totalCount: res.totalCount,
                designations: res.designations,
                totalDepartments: res.totalDepartments
              })
            ),
            catchError(error => of(loadDesignationsFailure({ error: error.message })))
          )
      )
    ),
  { functional: true }
)

export const createDesignation$ = createEffect(
  (
    actions$ = inject(Actions),
    designationService = inject(DesignationService),
    toastr = inject(ToastrService), // Inject the ToastrService
    store = inject(Store),
    modalService = inject(NgbModal)
  ) =>
    actions$.pipe(
      ofType(createDesignation),
      exhaustMap(({ designationName, departmentId, businessId }) =>
        designationService.createDesignation({ designationName, departmentId, businessId }).pipe(
          map(created => {
            // Dispatch the success action
            const successAction = createDesignationSuccess({ designation: created })

            // Show a success message using Toastr
            toastr.success('Designation created successfully!', 'Success')
            // store.dispatch(loadDesignations({ params: null, page: 1, limit: 10 }))
            modalService.dismissAll()
            return successAction
          }),
          catchError(error => {
            // Optionally, show an error message
            toastr.error(error.error.message, 'Error')

            return of(createDesignationFailure({ error }))
          })
        )
      )
    ),
  { functional: true, dispatch: true }
)

export const updateDesignation$ = createEffect(
  (
    actions$ = inject(Actions),
    designationService = inject(DesignationService),
    toastr = inject(ToastrService),
    store = inject(Store),
    modalService = inject(NgbModal)
  ) =>
    actions$.pipe(
      ofType(updateDesignation),
      exhaustMap(({ id, designationName, departmentId, businessId }) =>
        designationService
          .updateDesignation({
            id,
            designationName,
            departmentId,
            businessId
          })
          .pipe(
            map(updatedDesignation => {
              toastr.success('Designation updated successfully!', 'Success')

              // Dispatch loadBusinessById after the update is successful
              // store.dispatch(loadDesignations({ params: null }))
              modalService.dismissAll()
              // Dispatch success action to update the store
              return updateDesignationSuccess({ designation: updatedDesignation })
            }),
            catchError(error => {
              toastr.error(error.error.message, 'Error')

              return of(updateDesignationFailure({ error }))
            })
          )
      )
    ),
  { functional: true }
)

export const blockDesignation$ = createEffect(
  (
    actions$ = inject(Actions),
    designationService = inject(DesignationService),
    store = inject(Store),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(blockDesignation),
      exhaustMap(action =>
        designationService.blockDesignation(action.id, action.disabled).pipe(
          map(res => {
            // const actionToDispatch =
            // console.log('Dispatching blockDesignationSuccess:', { designation: res })
            // store.dispatch(actionToDispatch) // Dispatch the action
            //dispatch block  business success action
            if (action.disabled === true) {
              // Fixed typo here
              toastr.success('Designation inactive successfully!')
            } else {
              toastr.success('Designation active successfully!')
            }
            // store.dispatch(loadDesignations({ params: null, page: 1, limit: 10 }))
            return blockDesignationSuccess({ designation: res })
            // return blockBusinessSuccess({ business: res })
            // return blockBusinessSuccess({ id: action.id })
          }),
          catchError(error => {
            toastr.error('Failed to block business: ' + error.message)
            return of(blockDesignationFailure({ error }))
          })
        )
      )
    ),
  { functional: true }
)

export const deleteDesignation$ = createEffect(
  (
    actions$ = inject(Actions),
    designationService = inject(DesignationService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(deleteDesignation),
      exhaustMap(action =>
        designationService.deleteDesignation(action.id).pipe(
          map(() => {
            toastr.success('Designation deleted successfully!')
            return deleteDesignationSuccess({ id: action.id })
          }),
          catchError(error => {
            toastr.error('Failed to delete Designation: ' + error.message)
            return of(deleteDesignationFailure({ error }))
          })
        )
      )
    ),
  { functional: true }
)

export const designationEffects = {
  loadDesignations$,
  createDesignation$,
  updateDesignation$,
  blockDesignation$,
  deleteDesignation$
}
